// src/components/charts/BarChartScopes.js

import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";

function safeNumber(x) {
  const n = Number(x);
  return Number.isFinite(n) ? n : 0;
}

const SCOPE_COLORS = {
  "Scope 1": "#134E4A",
  "Scope 2": "#2FAF7A",
  "Scope 3": "#96bdab",
};

export default function BarChartScopes({ summary, captureId, compact = false }) {
  const data = useMemo(() => {
    return [
      { name: "Scope 1", value: safeNumber(summary?.scope_1_kgco2e) },
      { name: "Scope 2", value: safeNumber(summary?.scope_2_kgco2e) },
      { name: "Scope 3", value: safeNumber(summary?.scope_3_kgco2e) },
    ];
  }, [summary]);

  const hasAny = useMemo(() => data.some((d) => d.value > 0), [data]);

  if (!hasAny) {
    return <div style={{ padding: 14, opacity: 0.75 }}>No scope breakdown available yet.</div>;
  }

  return (
    <div id={captureId} className="scope-bar-chart">
      <div className="scope-bar-chart-canvas" style={{ height: compact ? 238 : 280 }}><ResponsiveContainer>
        <BarChart data={data} margin={{ top: 10, right: 18, left: 0, bottom: 30 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(v) => `${Math.round(v)}`} />

          <Tooltip
            formatter={(value) => [`${Number(value).toLocaleString()} kg CO₂e`, "Emissions"]}
          />

          <Bar dataKey="value" radius={[8, 8, 0, 0]}>
            {data.map((entry) => (
              <Cell key={entry.name} fill={SCOPE_COLORS[entry.name]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer></div>

      {/* Custom legend */}
      <div
        className="scope-bar-chart-legend"
        style={
          compact
            ? undefined
            : {
                display: "flex",
                justifyContent: "center",
                gap: 25,
                marginTop: -13,
                fontSize: 13,
              }
        }
      >
        {data.map((d) => (
          <div key={d.name} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: SCOPE_COLORS[d.name],
                display: "inline-block",
              }}
            />
            {d.name}
          </div>
        ))}
      </div>
    </div>
  );
}
